import { useEffect, useState } from 'react';
import Loader from '../Layout/Loader';
import { exportToExcel, setTitle, setFocus, BindReportGridWithCheckBox, BindReportGrid, } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
import { getCommonData } from '../Common/CommanServices';

const ActualVirtualItemMapping = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token');
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [MenuText, setMenuText] = useState("Actual Virtual Item Mapping");

    const [EmptyItemGroupOption, setEmptyItemGroupOption] = useState([]);
    const [IsVirtaulItemUpdated, setIsVirtaulItemUpdated] = useState(false);

    const [tableData, setTableData] = useState({});

    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    });

    const [SaveData, setSaveData] = useState({
        ActualVirtualItemMappingID: "0",
        VirtualItem: "",
        actualItemCode: []
    });

    // reset
    const handleClear = () => {
        setSaveData({
            ActualVirtualItemMappingID: "0",
            VirtualItem: "",
            actualItemCode: []
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setTableData({ totalRecord: 0, Data: [{}] });
        setIsUpdate(!isUpdate);
    };

    useEffect(() => {
        setTitle('ActualVirtualItemMapping', setOpen);
        setFocus('txtVirtualItem');
        setTimeout(() => setMenuText(document.title), 500);
    }, []);

    useEffect(() => {
        getItemData();
    }, [filterData.PageIndex, isUpdate]);
    const handleSubmit = () => {
        setIsLoading(true);
        const loginCodeString = String(LoginUserCode);

        const data = {
            Token,
            LoginUserCode: loginCodeString,
            ActualVirtualItemMappingID: SaveData.ActualVirtualItemMappingID,
            VirtualItem: SaveData.VirtualItem,
            actualItemCode: tableData?.Data?.filter(ele => ele.checkStatus).map((ele, i) => ({
                actualItemCode: ele["Item Code"]
            }))
        };
        post(`${API_SERVER}/api/Operation/ActualVirtualItemMapping`, data, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                handleClear();
            } else if (res.message === "EXPIRED") {
                navigate('/Login');
            } else {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false);
        });
    };

    const getItemData = (Type = 'S', value, PI = filterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`, VirtualItem: value,
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Operation/ShowActualItem`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res,
                        Data: res.Data.map(item => ({
                            ...item,
                            checkStatus: item?.CheckBox?.toUpperCase() === 'TRUE' ? true : false
                        }))
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'ActualVirtualItemMapping');

                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({});
            }
            setIsLoading(false)
        })
    }
    const handleChange1 = (event, value) => {
        getItemData("S", SaveData.VirtualItem, value);
        console.log(value)
    };

    const handleCheck = (checked, item, index) => {
        setTableData(prev => {
            const newData = prev.Data.map((row, i) =>
                i === index ? { ...row, checkStatus: checked } : row
            );
            return { ...prev, Data: newData };
        });
    };

    const handleAllchange = (e) => {
        const { checked } = e.target;
        setTableData(prev => {
            const newData = prev.Data.map(row => ({ ...row, checkStatus: checked }));
            return { ...prev, Data: newData };
        });
    };

    const getItem = () => {
        setEmptyItemGroupOption([]);
        let temp = {
            Type: "GetEmptyItemGroupList",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = { Token, LoginUserCode: loginCodeString };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let ItemData = res.autoCompleteData || [];
                setEmptyItemGroupOption(ItemData);
            } else {
                setEmptyItemGroupOption([]);
            }
        });
    };

    let EmptyItemOptionArr = [];
    for (let i = 0; i < EmptyItemGroupOption.length; i++) {
        let mydata = EmptyItemGroupOption[i]?.values;
        EmptyItemOptionArr.push(mydata);
    }

    const searchHandle = () => {
        if (SaveData.VirtualItem) {
            getItemData("S", SaveData.VirtualItem);
        }
    };

    //const handleDownloadExcel = () => {
    //    if (tableData.Data && tableData.Data.length > 0) {
    //        exportToExcel(tableData.Data, 'ActualVirtualItemMapping');
    //    } else {
    //        AlertBox('ERROR', 'No data to export');
    //    }
    //};

    useEffect(() => {
        if (IsVirtaulItemUpdated) {
            getItemData("S", SaveData.VirtualItem)
            setIsVirtaulItemUpdated(false)
        }
    }, [IsVirtaulItemUpdated])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>

                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') setFocus("btnSave");
                                                }}
                                                label='Virtual Item'
                                                placeholder="Enter Virtual Item"
                                                maxLength='50'
                                                options={EmptyItemOptionArr}
                                                id='txtVirtualItem'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getItem()}
                                                value={SaveData.VirtualItem} 
                                                inputValue={SaveData.VirtualItem}
                                                onInputChange={(event, newInputValue) => {
                                                    setSaveData({ ...SaveData, VirtualItem: newInputValue || '' });
                                                }}
                                                onChange={(event, newValue) => {
                                                    setSaveData({ ...SaveData, VirtualItem: newValue || '' });
                                                    setIsVirtaulItemUpdated(true)
                                                }}
                                            />

                                        </div>
                                    </div>

                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.ActualVirtualItemMappingID !== '0' ?
                                                (isLoading ?
                                                    <button className="button save-btn btn-disable" disabled> Please wait... </button>
                                                    :
                                                    <button className="button save-btn" onClick={handleSubmit}>
                                                        <i className="bi bi-check-lg" /> Update
                                                    </button>
                                                ) :
                                                (isLoading ?
                                                    <button className="button save-btn btn-disable" disabled> Please wait... </button>
                                                    :
                                                    <button className="button save-btn" id="btnSave" onClick={handleSubmit}>
                                                        <i className="bi bi-check-lg" /> Save
                                                    </button>
                                                )}
                                            {/*<button className="button export-btn" onClick={handleDownloadExcel}>*/}
                                            {/*    <i className="bi bi-download" /> Export*/}
                                            {/*</button>*/}
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <BindReportGrid
                tableData={tableData}
                setFilterData={setFilterData}
                filterData={filterData}
                handleChange1={handleChange1}
                currentPageNo={currentPageNo}
                handleCheckboxChange={handleCheck}
                handleAllchange={handleAllchange} 
            />
            {isLoading && <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' />}
        </main>
    );
};

export default ActualVirtualItemMapping;
